
import { useEffect, useRef } from "react";

interface ScrollObserverProps {
  children: React.ReactNode;
}

const ScrollObserver = ({ children }: ScrollObserverProps) => {
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    if (!observerRef.current) {
      observerRef.current = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              requestAnimationFrame(() => {
                entry.target.classList.add("animate-fade-in");
              });
              observerRef.current?.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.05, rootMargin: "0px 0px -100px 0px" }
      );
    }

    requestAnimationFrame(() => {
      document.querySelectorAll(".animate-on-scroll").forEach((element) => {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight) {
          element.classList.add("animate-fade-in");
          element.classList.remove("opacity-0");
        } else {
          observerRef.current?.observe(element);
        }
      });
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return <>{children}</>;
};

export default ScrollObserver;
